module.exports = __webpack_public_path__ + "static/media/minus.9fd01b0b.svg";